import { render, staticRenderFns } from "./RequestClassificationChart.vue?vue&type=template&id=39be4f3f&"
import script from "./RequestClassificationChart.vue?vue&type=script&lang=js&"
export * from "./RequestClassificationChart.vue?vue&type=script&lang=js&"
import style0 from "./RequestClassificationChart.vue?vue&type=style&index=0&id=39be4f3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports